import { render } from "./OTPEmail.vue?vue&type=template&id=4571874a&scoped=true"
import script from "./OTPEmail.vue?vue&type=script&lang=js"
export * from "./OTPEmail.vue?vue&type=script&lang=js"

import "./OTPEmail.vue?vue&type=style&index=0&id=4571874a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4571874a"]])

export default __exports__